import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Alert,
  CircularProgress
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import GamificationForm from '../components/Insurance/GamificationForm';

const InsuranceFlow = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const insuranceNames = {
    auto: 'Car Insurance',
    health: 'Health Insurance',
    life: 'Term Life Insurance',
    travel: 'Travel Insurance',
    home: 'Home Insurance',
    investment: 'Investment and Life Plans',
    corporate_health: 'Corporate Health',
    critical_illness: 'Critical Illness',
    business: 'Business Insurance',
    income_protection: 'Income Protection',
    child_education: 'Child Education Plan',
    capital_guarantee: 'Capital Guarantee Plan',
    bike: 'Bike Insurance',
    professional_indemnity: 'Professional Indemnity'
  };

  const handleFormComplete = async (userProfile) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/v1/products/match', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('auth_token') || ''}`
        },
        body: JSON.stringify(userProfile)
      });

      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.message || 'Failed to get matches');
      }

      const data = await response.json();

      navigate('/insurance-results', {
        state: {
          userProfile,
          matches: data.data?.matches ?? [],
          allResults: data.data?.all_results ?? []
        }
      });
    } catch (err) {
      console.error('Matching error:', err);
      setError(err.message || 'Failed to get insurance matches');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate('/')} sx={{ mb: 3 }}>
        Back to Home
      </Button>

      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          {insuranceNames[category] || 'Insurance'}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Answer a few quick questions to find your perfect match
        </Typography>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {loading ? (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <CircularProgress size={60} />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Finding your best matches...
          </Typography>
        </Box>
      ) : (
        <GamificationForm insuranceType={category} onComplete={handleFormComplete} />
      )}
    </Container>
  );
};

export default InsuranceFlow;
